import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

import { AiIcon } from './ai-icon';
import styles from './toolbar-button-scss';

export const ToolbarButtonSmall: React.FC<{ showLabel: boolean }> = ({ showLabel }) => {
  const { t } = useContext(RicosContext);
  return (
    <span className={styles.button}>
      <AiIcon /> {showLabel && t('AIPlugin_ToolbarButton_Text')}
    </span>
  );
};
